import { Divider, Group, Stack, Text } from '@mantine/core'
import { HowToPlayBullet } from '../shared/howToPlayShared'
import { IconGlyph } from '../../ui/atoms/Icons'
import { ArrowClockwiseIcon } from '@phosphor-icons/react'

export function RebootHowToPlay() {
  return (
    <Stack gap={24} ff="Tilt Neon, sans-serif" w={290}>
      <Stack gap={12} align="center">
        <Stack gap={2}>
          <Text fz={16} ta="center" opacity={0.7} lh={1.3} w={180}>
            Tiles refill when
          </Text>
          <Text fz={16} ta="center" opacity={0.7} lh={1.3} w={180}>
            the board is cleared
          </Text>
        </Stack>
        <Divider
          label="OR"
          w={100}
          color="rgba(255, 255, 255, 0.1)"
          styles={{
            label: {
              color: 'rgba(255, 255, 255, 0.3)',
            },
          }}
        />
        <Group gap={8} align="center">
          <Group gap={5} c="#caa46a">
            <IconGlyph icon={ArrowClockwiseIcon} size={16} />
            <Text span>Reset</Text>
          </Group>
          <Text fz={16} ta="center" opacity={0.7}>
            is used
          </Text>
        </Group>
      </Stack>
      <Stack gap={12} mt={12}>
        <HowToPlayBullet>Scoring is unlimited:</HowToPlayBullet>
        <Stack gap={6} pl={0}>
          <Group gap={5} align="baseline">
            <Text fz={16} ta="center" opacity={0.7}>
              3-letter words: {' '}
            </Text>
            <Text span c="yellow" fw={600} fz={18}>
              1
            </Text>{' '}
          </Group>
          <Group gap={5} align="baseline">
            <Text fz={16} ta="center" opacity={0.7}>
              Additional letters: {' '}
            </Text>
            <Text span c="yellow" fw={600} fz={22}>
              +1
            </Text>{' '}
            <Text span fw={400} c="#ffef8e" fz={13}>
              (Each)
            </Text>
          </Group>
        </Stack>
      </Stack>
      <HowToPlayBullet w={260}>
        <Stack gap={4}>
          <Group gap={4}>
            Gold tiles score{' '}
            <Text span c="yellow" fw={600} fz={22} ml={2}>
              +1
            </Text>
          </Group>
          <Text span fw={400} c="#ffef8e" fz={13}>
            (Every usage)
          </Text>
        </Stack>
      </HowToPlayBullet>
      <HowToPlayBullet w={280}>
        Clear the board for {' '}
        <Text span c="yellow" fw={600} fz={22}>
          +5
        </Text>
      </HowToPlayBullet>
    </Stack>
  )
}
